<template>
  <div class="w-full">
    <div class="sticky top-0 z-10 flex items-center justify-between h-16 px-4 bg-white border-b lg:px-6">
      <h1 class="text-lg font-bold">
        Bookings
      </h1>
    </div>
    
    <Loading v-if="loading" class="p-8" />

    <div v-else>
      <!-- No Results -->
      <div v-if="bookings.meta.total < 1" class="px-6 py-12 text-center text-gray-500">
        You haven't made any bookings yet.
      </div>

      <!-- Results -->
      <div v-else>
        <!-- List -->
        <div class="divide-y">
          <div class="hidden px-6 py-3 text-xs font-medium tracking-wide text-gray-500 uppercase bg-gray-50 lg:grid lg:grid-cols-7">
            <div>
              Placed At
            </div>
            <div class="lg:col-span-3">
              Addresses
            </div>
            <div>
              Date
            </div>
            <div>
              Time
            </div>
            <div class="text-right">
              Status
            </div>
          </div>
          <router-link :to="{ name: 'CustomerBookingView', params: { id: booking.id } }" v-for="booking in bookings.data" :key="booking.id" class="relative grid grid-flow-row gap-4 px-6 py-3 text-gray-800 lg:grid-cols-7 lg:grid-flow-col hover:bg-gray-50 hover:no-underline">
            <div class="font-medium">
              {{ booking.created_at | moment('DD MMM YYYY') }}
            </div>
            <div class="grid col-span-3 truncate gap-y-2">
              <div>
                <div class="text-xs font-bold tracking-wider text-gray-500 uppercase">
                  {{ booking.origins.length || 'No' }}
                  {{ booking.origins.length | pluralize('Pickup') }}
                </div>
                <div v-for="origin in booking.origins" :key="origin.id">
                  {{ origin.contact_name }} 
                  <span v-if="origin.name" class="text-gray-600">
                    &mdash; {{ origin.name }}
                  </span>
                </div>
              </div>
              <div>
                <div class="text-xs font-bold tracking-wider text-gray-500 uppercase">
                  {{ booking.destinations.length || 'No' }}
                  {{ booking.destinations.length | pluralize(['Delivery', 'Deliveries']) }}
                </div>
                <div v-for="destination in booking.destinations" :key="destination.id">
                  {{ destination.contact_name }}
                  <span v-if="destination.name" class="text-gray-600">
                    &mdash; {{ destination.name }} 
                  </span>
                </div>
              </div>
            </div>
            <div>
              <span v-if="booking.date">{{ booking.date | moment('ddd DD MMM YYYY') }}</span>
              <span v-else class="text-gray-400">None</span>
            </div>
            <div>
              <span v-if="booking.time">{{ booking.time }}</span>
              <span v-else class="text-gray-400">None</span>
            </div>
            <div class="text-right">
              <span class="px-3 py-1 text-xs font-medium tracking-wide uppercase border rounded-full" :class="statusClass(booking.status)">
                {{ booking.status }}
              </span>
            </div>
          </router-link>
        </div>
        <!-- Pagination -->
        <Pagination class="border-t rounded-b-lg" :total="bookings.meta.total" :per-page="bookings.meta.per_page" :current-page="bookings.meta.current_page" />
      </div>
    </div>
  </div>
</template>

<script>
import { sub } from 'date-fns'

export default {
  name: 'CustomerBookings',

  created () {
    this.getBookings()
  },

  data () {
    return {
      loading: true,
      bookings: {},
      filter: {
        created_at: { start: sub(new Date(), { years: 1 }), end: new Date() }
      }
    }
  },

  methods: {
    async getBookings () {
      try {
        const { data } = await this.$api.get(`portal/${this.$store.state.portal.subdomain}/customer/bookings/`, {
          params: {
            page: this.$route.query.page || 1,
            sort: this.$route.query.sort || 'date',
            dir: this.$route.query.dir || 'desc',
            ...this.filter && { filter: this.filter }
          }
        })
        this.bookings = data.bookings
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    statusClass (status) {
      if (status === 'pending') { 
        return `bg-gray-50 border-gray-500 text-gray-500`
      } else if (status === 'approved') { 
        return `bg-emerald-100 border-emerald-600 text-emerald-600`
      } else if (status === 'cancelled') { 
        return `bg-red-100 border-red-600 text-red-600`
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getBookings()
      },
      deep: true
    }
  }
}
</script>
